// extracted by mini-css-extract-plugin
export default {"customCell":"ApiKeysTable_customCell__rm2Ne","deleteButton":"ApiKeysTable_deleteButton__4bUbY"};